import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from 'recharts';
import CalcDetail from './CalcDetail';

/**
 * Channel mix pie chart
 * Shows distribution of orders by channel (online vs in-person)
 */
export default function ChannelMixChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className="chart-container channel-mix-chart">
        <h3>Distribución por Canal</h3>
        <div className="empty-state">
          <p>No hay datos para mostrar la distribución</p>
        </div>
      </div>
    );
  }

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      return (
        <div className="chart-tooltip">
          <p style={{ color: item.color, fontWeight: 600 }}>{item.name}</p>
          <p>
            <strong>{item.value.toLocaleString()}</strong> órdenes ({item.percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    if (percent < 0.05) return null; // Don't show labels for small slices

    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="#fff"
        textAnchor="middle"
        dominantBaseline="central"
        style={{ fontSize: '13px', fontWeight: 600 }}
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  const CustomLegend = ({ payload }) => (
    <div className="product-mix-legend">
      {payload.map((entry, index) => (
        <div key={`legend-${index}`} className="legend-item">
          <span
            className="legend-color"
            style={{ backgroundColor: entry.color }}
          />
          <span className="legend-label">{entry.value}</span>
          <span className="legend-value">
            {data.find((d) => d.name === entry.value)?.value.toLocaleString()}
          </span>
        </div>
      ))}
    </div>
  );

  // Generate aria label with data summary
  const channelSummary = data.map((d) => `${d.name}: ${d.percentage}%`).join(', ');
  const ariaLabel = `Gráfica circular mostrando distribución de órdenes por canal. ${channelSummary}.`;

  return (
    <div className="chart-container channel-mix-chart" role="figure" aria-label={ariaLabel}>
      <h3>Distribución por Canal</h3>
      <CalcDetail>
        En Linea = orden sin cajero asignado. En Tienda = orden con cajero. Porcentaje = canal ÷ total × 100.
      </CalcDetail>

      <div className="product-mix-content">
        <ResponsiveContainer width="100%" height={260}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={100}
              innerRadius={40}
              dataKey="value"
              paddingAngle={2}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend content={<CustomLegend />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
